var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from "../../../pxc_editor_web/src/store";
import { setPrinting } from "../../../pxc_editor_web/src/actions/main";
import { isWebComponentEnvironment, getElementByGetElementById } from "../../../pxc_editor_web/src/helpers";
import Printing from "./Printing";
export default function backgroundPrint(printSettings, finishCallback) {
    if (finishCallback === void 0) { finishCallback = null; }
    var wrapEl = addWrapEl();
    var root = createRoot(wrapEl);
    store.dispatch(setPrinting(true));
    var handleFinishCalback = function () {
        store.dispatch(setPrinting(false));
        if (finishCallback) {
            finishCallback();
        }
        wrapEl.remove();
    };
    root.render(React.createElement(Provider, { store: store },
        React.createElement(Printing, __assign({}, printSettings, { finishCallback: handleFinishCalback }))));
}
function addWrapEl() {
    var _a;
    var webComponent = isWebComponentEnvironment();
    var docBody = document.querySelector('body');
    var wrapEl = document.createElement('div');
    wrapEl.style.position = 'fixed';
    wrapEl.style.zIndex = '-1000';
    wrapEl.style.opacity = '0';
    if (webComponent) {
        (_a = getElementByGetElementById('background-printing')) === null || _a === void 0 ? void 0 : _a.appendChild(wrapEl);
    }
    else if (docBody) {
        docBody.appendChild(wrapEl);
    }
    return wrapEl;
}
